import { PostProperties } from "../types";
import image from "../img/lostGemTakaakiItoh.jpg";

const post: PostProperties = {
  id: 10,
  title: "Takaaki Itoh - Logic, Sendai, Japan (08.07.2008)",
  content: " ",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/takaakiitoh-logicsendaijapan08072008",
  category: "Lost Gem",
};

export default post;
